import axios from "axios"

export const baseURL = `${process.env.APP_BASE}/api/v1/participant-only`

const instance = axios.create({
    timeout: 10000, // timeout - 10s
    baseURL,
})
instance.defaults.headers.post["Content-Type"] = "application/json"

instance.interceptors.request.use(
    (config) => {
        const participantPublicAccessToken = JSON.parse(localStorage.getItem("participantPublicAccessToken"))
        config.headers.Authorization = participantPublicAccessToken ? `Bearer ${participantPublicAccessToken}` : ""
        return config
    },
    (error) => {
        return Promise.reject(error.response)
    }
)
instance.interceptors.response.use(
    (response) => {
        if (response.data.status === 0) {
            return response.data
        }
        return Promise.reject(response.data.message)
    },
    (error) => {
        if (!error.response) {
            if (error.code === "ECONNABORTED") {
                error.message = "Request Timeout"
                return Promise.reject(error)
            }
            return Promise.reject(error)
        }
        if (error.response) {
            if (error.response.status === 504) {
                error.response.data = { data: { message: "Error on Request Sending. App server crashed" } }
            }
            return Promise.reject(error.response.data)
        }
        return Promise.reject(error.response.data)
    }
)

export const requestGet = (url, params, config = {}) => {
    return new Promise((resolve, reject) => {
        instance({
            method: "get",
            url,
            params,
            ...config,
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const requestPost = (url, data, config = {}) => {
    return new Promise((resolve, reject) => {
        instance({
            method: "post",
            url,
            data,
            ...config,
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const requestPut = (url, data, config = {}) => {
    return new Promise((resolve, reject) => {
        instance({
            method: "put",
            url,
            data,
            ...config,
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const requestPatch = (url, data, config = {}) => {
    return new Promise((resolve, reject) => {
        instance({
            method: "patch",
            url,
            data,
            ...config,
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const requestDelete = (url, params, config = {}) => {
    return new Promise((resolve, reject) => {
        instance({
            method: "delete",
            url,
            params,
            ...config,
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
